import useAxios from "axios-hooks";
import { useNavigate, useParams } from "react-router-dom";
import { UserResDto, UsersResDto } from "../../api/Api";

import {
  CheckIcon,
  KeyIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import ConfirmationButton from "../../components/button/ConfirmationButton";
import ClassroomForm from "./form/ClassroomForm";

export default function ClassroomSettings(props: {}) {
  const params = useParams();
  const navigate = useNavigate();

  const [{ data, loading, error }, getClassroom] = useAxios<UserResDto>(
    `/classrooms/${params.classroomId}`
  );

  const [
    { data: deleteData, loading: deleteLoading, error: deleteError },
    deleteMember,
  ] = useAxios<UserResDto>(
    {
      url: `/classrooms/${params.classroomId}`,
      method: "DELETE",
    },
    { manual: true }
  );

  const handleDelete = async () => {
    try {
      await deleteMember();
      navigate("/classrooms");
    } catch (error) {}
  };

  if (loading) return <h1>Loading...</h1>;

  if (deleteLoading) return <h1>Deleting Classroom...</h1>;

  return (
    <div className="flex flex-col gap-4">
      <div className="card bg-base-200 w-1/2">
        <div className="card-body">
          <ClassroomForm
            defaultValues={data}
            onSuccess={() => {
              getClassroom();
            }}
          ></ClassroomForm>
          <div className="divider"></div>

          <div className="flex flex-col gap-4">
            <div className="join">
              <div className="  w-full">
                <ConfirmationButton
                  id={"delete_member_modal"}
                  buttonText={"DELETE"}
                  body={`Are you sure you want to delete classroom '${data?.name}' ?`}
                  title={"Delete Classroom"}
                  onAccept={handleDelete}
                  onReject={() => {}}
                  className={"btn btn-ghost btn-xs w-full join-item text-error"}
                  icon={<TrashIcon className="h-4"></TrashIcon>}
                ></ConfirmationButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
